import React from "react";
import { PanelEditUser } from "../../../../UI/Users/Edit/PanelEditUser";
import {PanelEditMembershipService} from "../../../../UI/MembershipService/Edit/PanelEditMembershipService";

const EditMembershipService = () => {
  return (
    <div>
      <PanelEditMembershipService />
    </div>
  );
};

export default React.memo(EditMembershipService);
